module.exports = __webpack_public_path__ + "img/key_features--mattress_options.90cfcf76.png";